'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getObjectId, getObjectName } from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
import { CALYPSO_LIGHT, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import TileMessage from '../tile-message/TileMessage';
import TileMessageBody from '../tile-message/TileMessageBody';
import TileMessageContent from '../tile-message/TileMessageContent';
import TileMessageThumbnail from '../tile-message/TileMessageThumbnail';
import CrmTicketCreatedHeader from './CrmTicketCreatedHeader';
import CrmTicketLink from './CrmTicketLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BodyText = styled.p.withConfig({
  displayName: "CrmTicketCreatedTile__BodyText",
  componentId: "sc-1j9qr3e-0"
})(["margin-bottom:0;"]);
const CrmTicketCreatedTile = ({
  message,
  onTicketLinkClick,
  positionDescriptors,
  portalId,
  senders,
  userId
}) => /*#__PURE__*/_jsx(TileMessage, {
  positionDescriptors: positionDescriptors,
  children: /*#__PURE__*/_jsxs(TileMessageBody, {
    align: 'center',
    children: [/*#__PURE__*/_jsx(TileMessageThumbnail, {
      children: /*#__PURE__*/_jsx(UIIconCircle, {
        name: "ticket",
        padding: 0.25,
        size: 16,
        className: "m-right-2",
        backgroundColor: CALYPSO_LIGHT,
        borderColor: CALYPSO_MEDIUM
      })
    }), /*#__PURE__*/_jsxs(TileMessageContent, {
      children: [/*#__PURE__*/_jsx(CrmTicketCreatedHeader, {
        message: message,
        senders: senders,
        userId: userId,
        portalId: portalId
      }), /*#__PURE__*/_jsx(BodyText, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.create",
          options: {
            ticketName: /*#__PURE__*/_jsx("b", {
              children: getObjectName(message)
            }),
            link: /*#__PURE__*/_jsx(CrmTicketLink, {
              objectId: getObjectId(message),
              portalId: portalId,
              onClick: onTicketLinkClick
            })
          }
        })
      })]
    })]
  })
});
CrmTicketCreatedTile.displayName = 'CrmTicketCreatedTile';
CrmTicketCreatedTile.propTypes = {
  message: RecordPropType('CrmObjectLifecycleUpdate').isRequired,
  onTicketLinkClick: PropTypes.func,
  portalId: PropTypes.number.isRequired,
  positionDescriptors: PositionDescriptors.isRequired,
  senders: SenderMap.isRequired,
  userId: PropTypes.number.isRequired
};
export default CrmTicketCreatedTile;